import { FEAGlobals } from "../../common";
import { BloombergBridgeClient } from "./BloombergBridgeClient";

/**
 * Automated setup function enabling use as preload on a Finsemble component.
 */
const setupBloombergBridgeClient = () => {
	// @ts-ignore
	// We add on to FSBL.Clients for backwards compatibility with the old API
	// This is soon to be deprecated once the Bloomberg API fully implement
	// as an FDC3 interface
	FEAGlobals.FSBL.Clients.BloombergBridgeClient = new BloombergBridgeClient();
	window.dispatchEvent(new Event("BloombergBridgeClientReady"));
};

if ((window as any).FSBL && (window as any).FSBL.addEventListener) {
	FEAGlobals.FSBL.addEventListener("onReady", setupBloombergBridgeClient);
} else {
	window.addEventListener("FSBLReady", setupBloombergBridgeClient);
}
